import { useDeleteChatroomMutation } from '@pba/react-chat-core';
import { useCallback, useMemo } from 'react';
import { Icon, Modal, message } from 'ui';

type P = {
  onSuccess: (chatroomId: string) => Promise<void> | void;
};

export const useDeleteChatConfirmModal = ({ onSuccess }: P) => {
  const [modal, contextHolder] = Modal.useModal();
  const { mutateAsync: deleteChatroom } = useDeleteChatroomMutation();

  const confirm = useCallback(
    (chatroomId: string) => {
      modal.confirm({
        content: 'Are you sure you want to delete this chat?',
        icon: <Icon color="error" icon="delete-2-line" />,
        okText: 'Delete',
        async onOk() {
          await deleteChatroom(
            { chatroomId },
            {
              onError() {
                message.error("Something went wrong. Chat couldn't be deleted.");
              },
              async onSuccess() {
                message.success('Chat deleted successfully');
                await onSuccess(chatroomId);
              },
            },
          );
        },
        title: 'Delete chat',
        type: 'error',
      });
    },
    [deleteChatroom, modal, onSuccess],
  );

  return useMemo(() => ({ confirm, contextHolder }), [confirm, contextHolder]);
};
